/**
 * Date cell renderer for custom table columns.
 * @module DateCell
 */

import moment from "moment";
import React from "react";

/** Props for the DateCell table cell renderer. */
interface DateCellProps {
  value: any;
  [key: string]: any;
}

/**
 * Renders a date value formatted as MM/DD/YYYY, or "N/A" when the value
 * is missing or unparseable.
 *
 * @param props - {@link DateCellProps}
 * @param props.value - Raw date value to format
 * @returns Formatted date string or "N/A"
 */
export const DateCell: React.FC<DateCellProps> = ({ value }) => {
  if (!value) return <>N/A</>;
  const parsed = moment(value);
  return <>{parsed.isValid() ? parsed.format("MM/DD/YYYY") : "N/A"}</>;
};

export default DateCell;
